import { FeedbackService } from '../../providers'

const FeedbackModule = {
  namespaced: true,
  actions: {
    async createFeedback (context, params) {
      const result = await FeedbackService.createFeedback(params)
      return result
    }
  }
}

export default FeedbackModule
